/* ============================================================================
   LAH — POSICAO DO CHAT NA PAGINA DE PRODUTO (celular)
   Tema: Testes de implementacao (8.0)

   ============================================================================
   PARAMOS DE DISPUTAR E PASSAMOS A INTERCEPTAR
   ============================================================================
   Ha um script em custom-main-product.liquid que empurra o chat 104px para
   cima, chamando adjustStyles no evento 'ready' do Tidio.

   Tentamos chamar depois dele — uma vez, e depois em cinco momentos ate 8
   segundos. Nao bastou: nao ha como garantir a ultima palavra numa corrida
   cujo relogio nao controlamos. Funcionava quando o widget carregava rapido e
   falhava quando demorava, e isso explica por que "ja tinha sido corrigido" e
   voltou a quebrar.

   Agora TROCAMOS A PROPRIA FUNCAO. Envolvemos adjustStyles numa versao nossa
   que, antes de repassar a chamada, substitui o valor do bottom pelo nosso.
   Nao importa mais quem chama por ultimo: toda chamada passa por aqui.

   Isso se chama envolver uma funcao de terceiro. E invasivo, e o preferimos a
   editar custom-main-product.liquid — 40 KB no coracao da pagina de compra,
   onde um erro tira a loja do ar. Aqui, se algo der errado, o pior caso e o
   chat voltar para os 104px.

   A SUBSTITUICAO E CIRURGICA: so mexemos em declaracoes de bottom dentro de
   regras que citam #tidio. Qualquer outro estilo que o app ou a pagina
   injetarem passa intacto.

   ============================================================================
   O VALOR
   ============================================================================
   8px deixa o chat na linha da barra de compra, que assenta a 24px. Os dois
   numeros medem coisas diferentes: 8px e do IFRAME, que tem folga interna
   antes do circulo. E a UNICA linha a ajustar.

   O env(safe-area-inset-bottom) soma a faixa do gesto nos iPhones sem botao
   fisico; sem ela o toque cairia no gesto do sistema.
   ============================================================================ */

(function () {
    'use strict';

    /* Pagina de produto — detectada pelo conteudo, nao por classe suposta. */
    var naPagina = !!document.querySelector('.custom-product-wrap') ||
                   !!document.querySelector('.openProductLens');

    if (!naPagina) return;

    /* A UNICA linha a ajustar. */
    var BASE = '8px';

    var ALTURA = 'calc(' + BASE + ' + env(safe-area-inset-bottom, 0px))';
    var REGRA = '@media (max-width: 999px) { #tidio { bottom: ' + ALTURA + ' !important; } }';

    var DEBUG = window.location.search.indexOf('lahdebug') !== -1;
    var envolvido = false;

    function log() {
        if (!DEBUG) return;
        try { console.log.apply(console, ['[lah-chat]'].concat([].slice.call(arguments))); } catch (e) {}
    }

    /* Troca qualquer "bottom: <valor>" pelo nosso, mas SO dentro de trechos que
       mencionam #tidio — e so quando o valor nao e ja o nosso. Estilos de
       outra natureza passam sem alteracao. */
    function corrigir(css) {
        if (typeof css !== 'string') return css;
        if (css.indexOf('#tidio') === -1) return css;
        if (css.indexOf(BASE) !== -1) return css;

        return css.replace(/bottom\s*:\s*[^;}]+/gi, 'bottom: ' + ALTURA);
    }

    function envolver() {
        var t = window.tidioChatApi;
        if (!t || !t.adjustStyles || envolvido) return false;

        var original = t.adjustStyles.bind(t);

        t.adjustStyles = function (css) {
            var novo = corrigir(css);

            if (novo !== css) log('chamada de terceiro corrigida');

            return original(novo);
        };

        envolvido = true;
        log('adjustStyles envolvido');

        /* Aplicamos a nossa regra agora tambem: se o script da pagina ja tiver
           rodado antes de chegarmos aqui, e isto que desfaz o 104px. */
        original(REGRA);
        log('posicao aplicada', BASE);

        return true;
    }

    /* O widget e injetado depois do carregamento e nao ha evento confiavel para
       o instante em que a API aparece. Tentamos por 15 segundos — quanto antes
       envolvermos, menos chance de o outro script agir sozinho. */
    var tentativas = 0;

    (function esperar() {
        if (envolver()) return;

        tentativas++;
        if (tentativas > 150) {
            log('tidioChatApi nao apareceu em 15s');
            return;
        }

        setTimeout(esperar, 100);
    })();

    document.addEventListener('tidioChat-ready', function () {
        setTimeout(envolver, 0);
    });
})();
